import { combineReducers } from "redux";
import LoginReducer from './LoginReducer';
import UserReducer from './UserReducer';
import SettingsReducer from './SettingsReducer';
import LayoutReducer from './LayoutReducer';
import PaymentReducer from './PaymentReducer';
import ErrorReducer from './ErrorReducer';
import ReportReducer from './ReportReducer';
import LocationReducer from './LocationReducer';
import BrandReducer from './BrandReducer';

const RootReducer = combineReducers({
  login: LoginReducer,
  user: UserReducer,
  layout: LayoutReducer,
  payment: PaymentReducer,
  error: ErrorReducer,
  report: ReportReducer,
  location: LocationReducer,
  settings: SettingsReducer,
  brand: BrandReducer
});

export default RootReducer;
